/**
 * Which workspace the app should be showing.
 *
 * This is one small decision with an order that matters, and getting it wrong
 * is expensive: it decided that invites created in a brand new workspace were
 * written against a different one. Hence a pure function with a test rather
 * than three inline `||`s.
 *
 *   preferred  an explicit request ("I just created this one, go there")
 *   current    what this tab is already showing - the user's live choice
 *   stored     localStorage, which is SHARED BETWEEN TABS and is therefore
 *              only a seed for a cold start, never an authority
 *   first      no idea, so the first workspace they belong to
 */
export function pickWorkspace(list, { preferred, current, stored } = {}) {
  const byId = (id) => (id ? list.find((w) => w.id === id) : null);
  return byId(preferred) || byId(current) || byId(stored) || list[0] || null;
}
